export default (theme) => ({
  weeklyEventCard: {
    display: 'flex',
    width: '100%',
    backgroundColor: `${theme.palette.background.dayShift}`,
    border: `1px solid ${theme.palette.borderColor.dayShift}`,
    padding: '6px 10px 10px',
    flexDirection: 'column',
    marginTop: '1px',
    marginBottom: '3px',
    cursor: 'default',
    position: 'relative',
  },
  nightShiftEventCard: {
    backgroundColor: `${theme.palette.background.nightShift}`,
    borderColor: `${theme.palette.borderColor.nightShift}`,
  },
  publishError: {
    boxShadow: '0px 0px 4px 1px #D14646',
  },
  statusItemIconWrapper: {
    width: '20px',
    height: '20px',
    textAlign: 'center',
    lineHeight: '17px',
    border: '1px solid',
    borderRadius: '3px',
    flexShrink: '0',
    backgroundColor: `${theme.palette.background.default}`,
  },
  expandIconWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    marginBottom: '-6px',
  },
  expandIconBase: {
    borderRadius: '4px',
    padding: '2px',
    paddingBottom: '4px',
    cursor: 'pointer',
  },
  iconImage: {
    transform: 'rotate(90deg)', // Rotate only the image
  },
  locationMark: {
    position: 'absolute',
    top: 0,
    right: 0,
    border: '7px solid transparent',
  },
  jobNumberWrapper: {
    display: 'flex',
    gap: '6px',
    width: '100%',
    alignItems: 'center'
  },
  jobNumber: {
    display: 'flex',
    fontSize: '14px',
    color: theme.palette.textColor.secondary,
  },
  titleWrapper: {
    marginTop: '6px',
  },
  contractorWrapper: {
    marginTop: '4px',
  },
  timeRangeWrapper: {
    marginTop: '6px',
  },
  popper: {
    display: 'flex',
    maxWidth: '440px',
    width: '100%',
    boxShadow: '0px 4px 14px 0px #00000040',
    borderRadius: 10,
    overflow: 'hidden',
    zIndex: 999,
    [theme.breakpoints.down('md')]: {
      width: '96%',
    },
  },
})